import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import {ConversationIconButton} from "@khanacademy/wonder-blocks-icon-button";
import {semanticColor} from "@khanacademy/wonder-blocks-tokens";
import {usePrefersReducedMotion} from "@khan/data-prefers-reduced-motion";

import cameraFill from "@phosphor-icons/core/fill/camera-fill.svg";

interface CameraButtonProps {
    disabled?: boolean;
    onClick: () => void;
}

// Pulsating animation keyframes
const pulseKeyframes = {
    "0%": {
        transform: "scale(1)",
        boxShadow: `0 0 0 0 ${semanticColor.core.border.instructive.subtle}`,
    },
    "50%": {
        transform: "scale(1.08)",
        boxShadow: `0 0 0 8px ${semanticColor.core.shadow.transparent.low}`,
    },
    "100%": {
        transform: "scale(1)",
        boxShadow: `0 0 0 0 ${semanticColor.core.border.instructive.subtle}`,
    },
};

/**
 * An animated button that supports a user capturing a still frame from a camera.
 */
export const CameraButton = ({disabled, onClick}: CameraButtonProps) => {
    const prefersReducedMotion = usePrefersReducedMotion();
    return (
        <ConversationIconButton
            disabled={disabled}
            aria-label={t`Capture image from camera`}
            onClick={onClick}
            icon={cameraFill}
            testId="camera-button-icon"
            style={
                !disabled && !prefersReducedMotion ? styles.pulsate : undefined
            }
        />
    );
};

const styles = StyleSheet.create({
    pulsate: {
        animationName: pulseKeyframes as any,
        animationDuration: "1.5s",
        animationIterationCount: "infinite",
        animationTimingFunction: "ease-in-out",
    },
});
